import { type Cause, PaymentStatus, QurbaniCategory, type Schedule } from '@shamaazi/mytennights'
import { DateTime } from 'luxon'

export const charityHasQurbaniCause = (charityCauses: Cause[]): boolean => {
  return charityCauses?.some(cause => cause.category === QurbaniCategory) ?? false
}

export const scheduleHasQurbaniCause = (schedule: Schedule, causes: Record<string, Cause>): boolean => {
  return schedule.causes?.some(cause => causes[cause.cause_id] ? causes[cause.cause_id].category === QurbaniCategory : false) ?? false
}

export const getScheduleNonQurbaniCauses = (schedule: Schedule, causes: Record<string, Cause>): Record<string, number> => {
  return Object.fromEntries(schedule.causes?.filter(cause => causes[cause.cause_id] ? causes[cause.cause_id].category !== QurbaniCategory : false).map(cause => [cause.cause_id, cause.amount]))
}

export const getScheduleQurbaniCauses = (schedule: Schedule, causes: Record<string, Cause>): Record<string, number> => {
  return Object.fromEntries(schedule.causes?.filter(cause => causes[cause.cause_id] ? causes[cause.cause_id].category === QurbaniCategory : false).map(cause => [cause.cause_id, cause.amount]))
}

// Qurbani payment is taken in full in one payment. Thsi function checks if that payment has been processed
export const hasQurbaniPaymentBeenProcessed = (schedule: Schedule, causes: Record<string, Cause>): boolean => {
  const payments = schedule.payments
  const paymentWithQurbani = payments.filter((payment) => payment.causes.some(cause => causes[cause.cause_id] ? causes[cause.cause_id].category === QurbaniCategory : false))[0]
  const now = DateTime.now()
  return paymentWithQurbani.date < now.startOf('day') || (paymentWithQurbani.date.hasSame(now, 'day') && paymentWithQurbani.status !== PaymentStatus.Pending)
}
